<div class="btn-group" role="group" [attr.aria-label]="ariaLabel">
  @for (label of buttons; track label) {
    <button
      type="button"
      class="btn btn-primary"
      [class.active]="selected === label"
      (click)="onClick(label)">
      {{ label }}
    </button>
  }
</div>
